import { CartStatusType } from '@notino/shared/definitions/types';

import {
  parseStatusesDeprecated,
  generateNotificationMessageDeprecated,
  parseStatuses,
} from '../../../utils';
import { IAddToCartResult, IDeprecatedAddToCartResult } from '../model';

import { getSettings } from './getSettings';
import { hasFatalError, createNotificationMessages } from './helpers';

export const addToCartResultDeprecated = ({
  data: { CartAddProductWithService },
  showAddToCartModal,
  disableRedirect,
  products,
}: IDeprecatedAddToCartResult) => {
  const response = CartAddProductWithService.productAddResponse;
  const cartSettings = getSettings(showAddToCartModal, disableRedirect);

  if (
    response.status !== CartStatusType.NotFound &&
    response.status !== CartStatusType.Error
  ) {
    return {
      success: true,
      cartSettings,
      statusMessages: parseStatusesDeprecated(CartAddProductWithService),
    };
  }

  return {
    success: false,
    notificationMessage: generateNotificationMessageDeprecated(
      response.products,
      products
    ),
  };
};

export const addToCartResult = ({
  response,
  showAddToCartModal,
  disableRedirect,
  products,
}: IAddToCartResult) => {
  const cartSettings = getSettings(showAddToCartModal, disableRedirect);

  const hasFatalErrors = hasFatalError(response.productAddResponse);

  const productById = (id: string) =>
    response.productAddResponse.find((p) => String(p.productId) === id);

  if (hasFatalErrors) {
    const notificationMessages = createNotificationMessages(
      products,
      productById
    );

    return {
      success: false,
      cartSettings,
      notificationMessage: notificationMessages[0],
    };
  }

  const statusMessages = products
    .map((product) => {
      const { productIncrease } = productById(product.id);

      return parseStatuses(
        response.serviceAddResponse,
        productIncrease,
        product.count
      );
    })
    .flat();

  return {
    success: true,
    cartSettings,
    statusMessages,
  };
};
